import { FieldErrors, UseFormRegister } from 'react-hook-form';
import { EmployerFormFields } from 'src/@types';
import { Box, Grid, Heading } from '@chakra-ui/react';
import { DynamicInput } from 'src/components/shared/form-elements';
import { employerStatementFormFields } from '../config';
import { validationMessages } from 'src/components/shared/validation/validation-messages';

export const EmployerStatementLoansSection = ({
  heading,
  register,
  values,
  errors
}: {
  heading: string;
  register: UseFormRegister<EmployerFormFields>;
  values: EmployerFormFields;
  errors: FieldErrors<EmployerFormFields>;
}) => {
  return (
    <>
      <Heading size={`md`}>{heading}</Heading>
      <Grid
        templateColumns={{
          base: 'repeat(1, 1fr)'
        }}
        gap={4}>
        <DynamicInput
          id={employerStatementFormFields.heeftOnderhandseLening.fieldName}
          label={employerStatementFormFields.heeftOnderhandseLening.label}
          type={employerStatementFormFields.heeftOnderhandseLening.type}
          validation={{ required: validationMessages.required }}
          tooltip={employerStatementFormFields.heeftOnderhandseLening.tooltip}
          error={errors.heeftOnderhandseLening}
          defaultValue={values.heeftOnderhandseLening}
          register={register}
          options={[
            { label: 'Ja', value: 'true' },
            { label: 'Nee', value: 'false' }
          ]}
        />
        {values.heeftOnderhandseLening === 'true' && (
          <Box>
            <DynamicInput
              id={employerStatementFormFields.ingangsdatumOnderhandseLening.fieldName}
              label={employerStatementFormFields.ingangsdatumOnderhandseLening.label}
              type={employerStatementFormFields.ingangsdatumOnderhandseLening.type}
              validation={{ required: validationMessages.required }}
              tooltip={employerStatementFormFields.ingangsdatumOnderhandseLening.tooltip}
              error={errors.ingangsdatumOnderhandseLening}
              register={register}
            />

            <DynamicInput
              id={employerStatementFormFields.hoofdsomOnderhandseLening.fieldName}
              label={employerStatementFormFields.hoofdsomOnderhandseLening.label}
              type={employerStatementFormFields.hoofdsomOnderhandseLening.type}
              validation={{ required: validationMessages.required }}
              tooltip={employerStatementFormFields.hoofdsomOnderhandseLening.tooltip}
              error={errors.percentageAandelen}
              register={register}
            />

            <DynamicInput
              id={employerStatementFormFields.jaarlastOnderhandseLening.fieldName}
              label={employerStatementFormFields.jaarlastOnderhandseLening.label}
              type={employerStatementFormFields.jaarlastOnderhandseLening.type}
              validation={{ required: validationMessages.required }}
              tooltip={employerStatementFormFields.jaarlastOnderhandseLening.tooltip}
              error={errors.percentageAandelen}
              register={register}
            />

            <DynamicInput
              id={employerStatementFormFields.looptijdOnderhandseLening.fieldName}
              label={employerStatementFormFields.looptijdOnderhandseLening.label}
              type={employerStatementFormFields.looptijdOnderhandseLening.type}
              validation={{ required: validationMessages.required }}
              tooltip={employerStatementFormFields.looptijdOnderhandseLening.tooltip}
              error={errors.percentageAandelen}
              register={register}
            />
          </Box>
        )}

        <DynamicInput
          id={employerStatementFormFields.heeftLoonbeslag.fieldName}
          label={employerStatementFormFields.heeftLoonbeslag.label}
          type={employerStatementFormFields.heeftLoonbeslag.type}
          validation={{ required: validationMessages.required }}
          tooltip={employerStatementFormFields.heeftLoonbeslag.tooltip}
          error={errors.heeftLoonbeslag}
          defaultValue={values.heeftLoonbeslag}
          register={register}
          options={[
            { label: 'Ja', value: 'true' },
            { label: 'Nee', value: 'false' }
          ]}
        />

        {values.heeftLoonbeslag === 'true' && (
          <Box>
            <DynamicInput
              id={employerStatementFormFields.einddatumLoonbeslag.fieldName}
              label={employerStatementFormFields.einddatumLoonbeslag.label}
              type={employerStatementFormFields.einddatumLoonbeslag.type}
              validation={{ required: validationMessages.required }}
              tooltip={employerStatementFormFields.einddatumLoonbeslag.tooltip}
              error={errors.einddatumLoonbeslag}
              register={register}
            />

            <DynamicInput
              id={employerStatementFormFields.maandlastPerMaandLoonbeslag.fieldName}
              label={employerStatementFormFields.maandlastPerMaandLoonbeslag.label}
              type={employerStatementFormFields.maandlastPerMaandLoonbeslag.type}
              validation={{ required: validationMessages.required }}
              tooltip={employerStatementFormFields.maandlastPerMaandLoonbeslag.tooltip}
              error={errors.maandlastPerMaandLoonbeslag}
              register={register}
            />
          </Box>
        )}
      </Grid>
    </>
  );
};
